const ADD_DEFAULT_SELECTIONS = 'ADD_DEFAULT_SELECTIONS';
export const CLEAR_DEFAULT_SELECTIONS = 'CLEAR_DEFAULT_SELECTIONS';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case ADD_DEFAULT_SELECTIONS:
      return { ...action.payload };
    case CLEAR_DEFAULT_SELECTIONS:
      return {};
    default:
      return state;
  }
}

export function addDefaultSelections(selections) {
  return {
    type: ADD_DEFAULT_SELECTIONS,
    payload: selections,
  };
}

export function removeDefaultSelections() {
  return {
    type: CLEAR_DEFAULT_SELECTIONS,
  };
}
